import { render } from "./ProdSubcategoriesListPage.vue?vue&type=template&id=3a65fb4c&ts=true"
import script from "./ProdSubcategoriesListPage.vue?vue&type=script&lang=ts"
export * from "./ProdSubcategoriesListPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__